import singleEvent from './singleEvent'
import carousel from './carousel'
import stats from './stats'

export default {
  singleEvent,
  carousel,
  stats
}



// WEBPACK FOOTER //
// ./src/library/cdu/templates/index.js